import PosthogService from '~/services/posthog/PosthogService';
import { UserProfession } from '~/enums/UserProfession';

// Event-specific interface (co-located)
export interface IPermPostJobBasicInfoSubmittedPayload {
  postingId: string;
  professionType: UserProfession;
}

/**
 * Fires when user submits basic info in the post job flow
 * Event: dental_portal:perm_post_job:basic_info_submitted
 */
export function firePermPostJobBasicInfoSubmitted(
  payload: IPermPostJobBasicInfoSubmittedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:perm_post_job:basic_info_submitted', {
    posting_id: payload.postingId,
    profession_type: payload.professionType,
  });
}